export default __webpack_public_path__ + "static/media/icon-20-icn-event-braking-2.eefdff66.svg";